<template>
  <div>
    <v-container fluid>
      <v-card
          @drop.prevent="onDrop($event)"
          @dragover.prevent="dragover = true"
          @dragenter.prevent="dragover = true"
          @dragleave.prevent="dragover = false"
      >
<!--        :class="{ 'grey lighten-2': dragover }"-->
<!--        <v-card-title v-if="storeDocItem" class="justify-center text-h6"-->
<!--        >{{ storeDocItem.title }}-->
<!--        </v-card-title>-->
        <v-progress-linear
            :active="loading"
            color="primary"
            indeterminate
            rounded
            height="2"
        ></v-progress-linear>
<!--        <v-divider></v-divider>-->
        <v-form disabledref="form"
                v-model="valid"
                lazy-validation>
          <v-card-text>
            <v-row dense class="my-0">
              <v-col cols="12" lg="6" md="6" sm="12" xs="12">
                <v-text-field
                    v-if="storeDocItem"
                    v-model="storeDocItem.title"
                    label="Title"
                    type="text"
                    filled
                    outlined
                    clearable
                    background-color="blue-grey lighten-3"
                    clear-icon="mdi-close-circle"
                    :rules="titleRules"
                    :counter="100"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="12" xs="12">
                <v-textarea
                    v-if="storeDocItem"
                    v-model="storeDocItem.description"
                    label="Description"
                    type="text"
                    filled
                    outlined
                    background-color="blue-grey lighten-3"
                    clearable
                    clear-icon="mdi-close-circle"
                    class="mb-n7"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-container>
    <StoreFileList
        v-bind:storeDocItemId="$route.params.storeDocItemId"
        hide-default-footer
        :height="$vuetify.breakpoint.height - 450"
        :searchTermFileParam="$route.params.searchTermFile"
    ></StoreFileList>
    <v-toolbar flat dense>
      <v-spacer></v-spacer>
      <BaseConformSave :disabled="!valid" class="mr-4" :on-save-external="onSaveItem" color="primary"
                       :loading="saveLoading">
      </BaseConformSave>
      <v-btn :to="{name: 'StoreDocList'}">Cancel</v-btn>
    </v-toolbar>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";
import StoreFileDialog from "@/components/StoreFile/StoreFileDialog";
import StoreFileList from "@/components/StoreFile/StoreFileList";
import BaseDeleteDialog from "@/components/BaseDeleteDialog";

import draggable from "vuedraggable"
import CommonArray from "@/commonFunction/arrayFunction";

export default {
  name: 'StoreDocItem',
  params: ['storeDocItemId', 'searchTermFile'],

  components: {
    StoreFileDialog,
    BaseDeleteDialog,
    StoreFileList,
    draggable,
  },

  computed: {
    ...mapGetters('StoreDocItem', []),
    ...mapFields('StoreDocItem', ['storeDocItem', 'saveLoading', 'loading', 'storeChildrenFileList']),
  },

  methods: {
    ...mapActions('StoreDocItem', ['fetchItem', 'fetchSaveItem', 'fetchChildList', 'fetchChildUpdateOrder', 'fetchChildAddItem']),
    ...mapActions('StoreFileList', ['fetchDeleteItem']),
    onSaveItem() {
      this.fetchSaveItem(this.storeDocItem)
    },
    onNewItem(item) {
      this.storeChildrenFileList.push(item)
    },
    onDeleteItem(item) {
      this.deleteLoading = true
      this.fetchDeleteItem(item)
      this.storeChildrenFileList = this.storeChildrenFileList.filter(row => row.id !== item.id)
      this.deleteLoading = false
    },
    onDragUpdate(event) {
      console.log('onDragUpdate', event)
      this.fetchChildUpdateOrder()
    },
    onDrop(e) {
      console.log('onDrop', e, e.dataTransfer.files, e.dataTransfer.items, e.dataTransfer.types)
      for (const type of e.dataTransfer.types) {
        let type_data = e.dataTransfer.getData(type)
        // console.log(type)
        console.log(type, type_data)
        const item = {title: type, html: type_data, store_doc: this.$route.params.storeDocItemId}
        console.log('Add new', item)
        if (type == 'text/html')
          this.fetchChildAddItem(item)
      }
      this.dragover = false;
      if (e.dataTransfer.files.length > 1) {
        this.$toast.warning("Only one file can be uploaded at a time..", {timeout: 5000})
      } else {
        for (const file of e.dataTransfer.files) {
          const item = {title: file.name, file: file, store_doc: this.$route.params.storeDocItemId}
          console.log('Add new', item)
          this.fetchChildAddItem(item)
        }
      }
    },
    onChangeDialog(destItem, srcItem) {
      CommonArray.copyObjectProperties(destItem, srcItem)
    }
  },

  async mounted() {
    await this.fetchItem(this.$route.params.storeDocItemId);
    await this.fetchChildList(this.$route.params.storeDocItemId);
  },

  data() {
    return {
      newItem: {},
      deleteLoading: false,
      valid: true,
      titleRules: [v => !!v || 'Title is required', v => (v && v.length <= 100) || 'Title must be less than 100 characters',],
      dragover: false,
    }
  }
}
</script>

<style scoped lang="scss">
.card_space {
  height: calc(100vh - 180px);
  overflow-y: auto;
}

.main_space {
  height: calc(100vh - 100px);
  overflow-y: auto;
}

.preview-iframe {
  width: 100%;
  height: 600px;
}
</style>
